const DEFAULT_CONSUMER_URL = 'https://chat.boty.bot';

/**
 * Returns the consumer app base URL with protocol prefix guaranteed.
 * Reads from NEXT_PUBLIC_CONSUMER_URL env var, falls back to default.
 */
export function getConsumerUrl(): string {
  const raw = process.env.NEXT_PUBLIC_CONSUMER_URL || DEFAULT_CONSUMER_URL;
  return raw.startsWith('http') ? raw : `https://${raw}`;
}
